export function getVersion() {
  return process.env.REACT_APP_BUILD_VERSION || 'development';
}

window.version = getVersion();
